import React from "react";

interface EmptyStateProps {
  title: string;
  description: string;
  /** Button (or anything) under the text. */
  action?: React.ReactNode;
  /** Illustration from /public; the coins-and-chart picture by default. */
  image?: string;
  compact?: boolean;
}

/** Empty state from the redesign: illustration, title, one line, action. */
export const EmptyState: React.FC<EmptyStateProps> = ({
  title,
  description,
  action,
  image = "/empty-positions.png",
  compact = false,
}) => (
  <div className={`flex flex-col items-center text-center ${compact ? "gap-4 py-6" : "gap-6 py-12"}`}>
    <img
      src={image}
      alt=""
      className={`object-contain ${compact ? "h-[96px] w-[170px]" : "h-[160px] w-[281px]"}`}
    />
    <div className="flex flex-col gap-2">
      <p className={`font-semibold text-[#fafafa] ${compact ? "text-xl leading-[30px]" : "text-2xl leading-8"}`}>
        {title}
      </p>
      <p className={`text-[#d4d4d4] ${compact ? "text-sm leading-5" : "text-base leading-6"}`}>
        {description}
      </p>
    </div>
    {action}
  </div>
);
